<template>
  <div class="slider-container as-flex flex-vertical main-start corss-start">
    <el-slider
      class="slider"
      :max="type==='box'?boxArray.length-1:yearArray.length-1"
      :step="1"
      v-model="value"
      :format-tooltip="generateTooltips"
      range
      show-stops
    ></el-slider>
    <div class="current-value as-flex main-end cross-center">{{label}}</div>
    <div class="function-bar as-flex main-end cross-center">
      <div class="confirm-btn" @click="confirm">确定</div>
    </div>
  </div>
</template>

<script>
import { clone } from "lodash";
import { boxArray, yearArray } from "../../config/boxAndYearMappingArray";
export default {
  name: "slider",
  props: {
    type: {}
  },
  data() {
    return {
      boxArray: clone(boxArray),
      yearArray: clone(yearArray),
      value: [0, 0]
    };
  },
  computed: {
    label: function() {
      let mappingArr = this.type === "box" ? boxArray : yearArray;
      let resArr = this.value.map(item => {
        return mappingArr[item].label;
      });
      return resArr.join("-");
    }
  },
  methods: {
    generateTooltips(value) {
      let mappingArr = this.type === "box" ? boxArray : yearArray;
      return mappingArr[value] ? mappingArr[value].label : null;
    },
    generateRangeValue() {
      let mappingArr = this.type === "box" ? boxArray : yearArray;
      return this.value.map(item => {
        return mappingArr[item];
      });
    },
    confirm() {
      let res = this.generateRangeValue();
      this.$emit("confirm", res);
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss" scoped>
.slider-container {
  width: 100%;
  height: 100%;
}
.current-value {
  margin: 15px;
}
.slider {
  height: 30px;
}
.function-bar {
  width: 100%;
  .confirm-btn {
    margin: 0 10px;
    color: #666666;
    cursor: pointer;
    &:hover {
      color: #61b6e6;
    }
  }
}
</style>
